// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import LogoutIcon from '@mui/icons-material/ExitToApp';
// import { Box,Divider, IconButton, Menu, MenuItem, ListItemText, Typography } from '@mui/material';
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// export default function UserActions() {

//   const [visible, setVisible] = useState(false);
//   const [loginId, setLoginId] = useState("");
//   const [name, setName] = useState("");
//   useEffect(() => {
//     var loginId = localStorage.getItem("loginId");
//     var name = helperServices.getLoggedUserName();
//     setLoginId(loginId);
//     setName(name.charAt(0).toUpperCase() + name.slice(1));
//   });

//   const toggleUserActions = () => {
//     setVisible(true);
//   };

//   const logout = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//   };
//   const [anchorEl, setAnchorEl] = React.useState(null);

//   const handleMenuClick = (event) => {
//     setAnchorEl(event.currentTarget);
//     toggleUserActions();
//   };

//   return (
//     // <NavItem tag={Dropdown} caret toggle={toggleUserActions}>
//     //   <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
//     //     <span className="d-md-inline-block">{name}</span>
//     //   </DropdownToggle>
//     //   <Collapse tag={DropdownMenu} right small open={visible}>
//     //     <DropdownItem divider />
//     //     <DropdownItem
//     //       tag={Link}
//     //       to="/"
//     //       onClick={(event) => logout()}
//     //       className="text-danger"
//     //     >
//     //       <i className="material-icons text-danger">&#xE879;</i> Logout
//     //     </DropdownItem>
//     //   </Collapse>
//     // </NavItem>

//     <React.Fragment>
//     <IconButton onClick={handleMenuClick}>
//     <Typography variant="body2" className="d-md-inline-block">
//           {name}
//         </Typography>
//         <ExpandMoreIcon />
//     </IconButton>
//     <Menu
//       anchorEl={anchorEl}
//       open={Boolean(anchorEl)}
//       onClose={handleClose}
//       anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//       transformOrigin={{ vertical: 'top', horizontal: 'right' }}
//     >
//       <UserCollectionCard />
//       <MenuItem component={Link} to="/" onClick={logout}>
//         <LogoutIcon color="error" />
//         <ListItemText className="p-2" primary="Logout" />
//       </MenuItem>
//     </Menu>
//   </React.Fragment>

// //  <React.Fragment>
// //   <IconButton onClick={handleMenuClick}>
// //     <Typography variant="body2" className="d-md-inline-block">
// //       {name}
// //     </Typography>
// //     <ExpandMoreIcon />
// //   </IconButton>

// //   <Menu
// //     anchorEl={anchorEl}
// //     open={Boolean(anchorEl)}
// //     onClose={handleClose}
// //     anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// //     transformOrigin={{ vertical: "top", horizontal: "right" }}
// //     PaperProps={{
// //       sx: { borderRadius: 2, minWidth: 260 }
// //     }}
// //   >
// //     {/* USER HEADER */}
// //     <Box px={2} py={1}>
// //       <Typography variant="subtitle2" fontWeight="bold">
// //         {name}
// //       </Typography>
// //       <Typography variant="caption" color="text.secondary">
// //         Net Collection
// //       </Typography>
// //     </Box>

// //     <Divider />

// //     {/* NET SUMMARY */}
// //     <Box px={2} py={1}>
// //       <SummaryRow label="Net Cash" value={netCash} />
// //       <SummaryRow label="Net Card" value={netCard} />
// //       <SummaryRow label="Net UPI" value={netUpi} />
// //     </Box>

// //     <Divider />

// //     {/* DOWNLOAD */}
// //     <MenuItem onClick={handleDownload}>
// //       <CalendarTodayIcon fontSize="small" />
// //       <ListItemText className="pl-2" primary="Download Report" />
// //     </MenuItem>

// //     <Divider />

// //     {/* LOGOUT */}
// //     <MenuItem component={Link} to="/" onClick={logout}>
// //       <LogoutIcon color="error" fontSize="small" />
// //       <ListItemText className="pl-2" primary="Logout" />
// //     </MenuItem>
// //   </Menu>
// //   </React.Fragment>

//   );
// }

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LogoutIcon from "@mui/icons-material/ExitToApp";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  Typography,
  Divider,
  ListItemIcon,
  Button,
  TextField,
  Dialog,
  Alert,
  InputAdornment,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import UserCollectionCard from "../../../collectionSummary/UserCollectionCard";
import { getCollectionSummary } from "../../../../core/actions/reportDownloadAction";
import doctorActions from "../../../../core/actions/doctorActions";
import {
  COMPONENT_TYPE_NULL,
  All_Component_Name,
} from "../../../../shared/constants";
import { helperServices } from "../../../../shared/helper";
import ProtectedComponent from "./../../../../components/common/ProtectedComponent";
import BackupDownloadMenu from "./../../../../components/MyReports/BackupDownloadMenu";
import { Visibility, VisibilityOff } from "@mui/icons-material";
export default function UserActions() {
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const [name, setName] = useState("");

  const [reportAnchor, setReportAnchor] = useState(null);

  const openReport = (event) => {
    setReportAnchor(event.currentTarget);
  };

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordData, setPasswordData] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [openPwdPopup, setOpenPwdPopup] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pwdError, setPwdError] = useState("");
  const [pwdSuccess, setPwdSuccess] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const closeReport = () => {
    setAnchorEl(null);
  };


  useEffect(() => {
    // const storedName = localStorage.getItem("userId") || "";
    const storedName = helperServices.getLoggedUserID() || "";
    setName(storedName.charAt(0).toUpperCase() + storedName.slice(1));
  }, []);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);

  
    dispatch(
      getCollectionSummary(
        {
          person: name,
          startdate: new Date().toISOString(),
          enddate: new Date().toISOString(),
        },
        () => { }
      )
    );
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
  };

  const canShowReportDownload =
    helperServices.CheckAccessLevel("ShowDownloadReport");

  const openChangePassword = () => {
    setNewPassword("");
    setConfirmPassword("");
    setPwdError("");
    setPwdSuccess("");
    setOpenPwdPopup(true);
  };

  const closeChangePassword = () => {
    setOpenPwdPopup(false);
  };

  const saveDoctorPassword = () => {
    if (!newPassword || !confirmPassword) {
      setPwdError("Password cannot be empty");
      return;
    }

    if (newPassword !== confirmPassword) {
      setPwdError("Passwords do not match");
      return;
    }

   
    const doctorInfo = JSON.parse(localStorage.getItem("staffInformation") || localStorage.getItem("doctorInformation"));

    console.log("doctorInfo from localStorage:", doctorInfo);

    if (!doctorInfo) {
      setPwdError("Doctor information not found. Please login again.");
      return;
    }

   
    const payload = {
      ...doctorInfo,
      password: newPassword 
    };

   
    if (payload.dob && typeof payload.dob === 'string') {
      payload.dob = new Date(payload.dob);
    }

   
    if (!payload.personId) {
      payload.personId = doctorInfo.personId || Number(localStorage.getItem("id"));
    }

    console.log("Payload being sent:", payload);

    dispatch(
      doctorActions.modifyDoctor(payload, (resCb) => {
        console.log("API Response:", resCb);

        if (resCb?.accresp?.success) {
          setPwdSuccess("Password changed successfully");

   
          const updatedDoctorInfo = { ...doctorInfo, password: newPassword };
          localStorage.setItem("doctorInformation", JSON.stringify(updatedDoctorInfo));

          setTimeout(() => {
            closeChangePassword();
          }, 1500);
        } else {
          setPwdError(resCb?.accresp?.error || "Unable to change password");
        }
      })
    );
  };

  return (
    <>
      <IconButton onClick={handleMenuClick}>
        <Typography variant="body2">{name}</Typography>
        <ExpandMoreIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        {canShowReportDownload && (
          <UserCollectionCard onCloseMenu={closeReport} />
        )}

        <Divider />

        <MenuItem onClick={openChangePassword}>
          <ListItemIcon>
            <i className="material-icons text-secondary">
              lock
            </i>
          </ListItemIcon>
          <ListItemText
            primary="Change Password"
            className="text-secondary"
          />
        </MenuItem>
        <ProtectedComponent
          componentName={All_Component_Name.DBBackupDownload}
          component={BackupDownloadMenu}
          pageType={COMPONENT_TYPE_NULL}
        />
        <MenuItem component={Link} to="/" onClick={logout}>
          <LogoutIcon color="error" />
          <ListItemText className="p-2" primary="Logout" />
        </MenuItem>
      </Menu>
      <Dialog open={openPwdPopup} onClose={closeChangePassword}>
        <div style={{ padding: 20, width: 350 }}>
          <h4>Change Password</h4>

          <TextField
            fullWidth
            type={showNewPassword ? "text" : "password"}
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    edge="end"
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />


          <TextField
            fullWidth
            type={showConfirmPassword ? "text" : "password"}
            label="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setShowConfirmPassword(!showConfirmPassword)
                    }
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />


          {pwdError && <Alert severity="error">{pwdError}</Alert>}
          {pwdSuccess && <Alert severity="success">{pwdSuccess}</Alert>}

          <div style={{ marginTop: 15, textAlign: "right" }}>
            <Button onClick={closeChangePassword}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={saveDoctorPassword}
              sx={{ ml: 1 }}
            >
              Save
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
}
